export default __webpack_public_path__ + "static/protections-droits-recours-conjoints-fait-quebec-services-avocat-30228dce3068e66673f1e3fbaada7bc4.jpeg";